export default __webpack_public_path__ + "static/media/AngsanaNew.936d54b1.svg";